import * as tslib_1 from "tslib";
import { Vue, Component, Prop } from "vue-ext";
var HobcutoutSelectionPopup = /** @class */ (function (_super) {
    tslib_1.__extends(HobcutoutSelectionPopup, _super);
    function HobcutoutSelectionPopup() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    Object.defineProperty(HobcutoutSelectionPopup.prototype, "hobcutout", {
        get: function () {
            return this.$state.hobcutout;
        },
        set: function (value) {
            var hobcutoutWasNull = this.$state.hobcutout == null;
            this.$state.hobcutout = value;
            if (value == "0") {
                this.$state.hobcutoutLength = null;
                this.$state.hobcutoutWidth = null;
                this.$state.hobcutoutDistanceY = null;
                this.$state.hobcutoutDistanceX = null;
            }
            //Skip hobcutout step if user has chosen "no hobcutout"
            if (hobcutoutWasNull && value == "0")
                this.$router.push("/accessories");
            this.close();
        },
        enumerable: true,
        configurable: true
    });
    HobcutoutSelectionPopup.prototype.close = function () {
        this.$emit("update:visible", false);
    };
    tslib_1.__decorate([
        Prop({ type: Boolean, default: false }),
        tslib_1.__metadata("design:type", Boolean)
    ], HobcutoutSelectionPopup.prototype, "visible", void 0);
    HobcutoutSelectionPopup = tslib_1.__decorate([
        Component
    ], HobcutoutSelectionPopup);
    return HobcutoutSelectionPopup;
}(Vue));
export default HobcutoutSelectionPopup;
